import { render, staticRenderFns } from "./mobileWeb.vue?vue&type=template&id=42dc5407"
import script from "./mobileWeb.vue?vue&type=script&lang=js"
export * from "./mobileWeb.vue?vue&type=script&lang=js"
import style0 from "./mobileWeb.vue?vue&type=style&index=0&id=42dc5407&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports